/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 21.06.25
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {Country} from "@shared/Country";

//TODO implement classes with decorator using @TypeClass
export default class BankingInfo extends BaseObject {

	type: Country = Country.UK;

	accountNumber: string = null;
	sortCode: string = null;
	accountName: string = null;

	constructor(data = {}) {
		super(data);
		this.accountNumber = data?.accountNumber || null;
		this.sortCode = data?.sortCode || null;
		this.accountName = data?.accountName || null;
	}

	accountNameFormatted(accountName){
		accountName = this.accountName || accountName;
		return accountName ? `${accountName}` : ""
	}

	accountNumberFormatted(){
		return this.accountNumber ? `Account Number: ${this.accountNumber}` : ""
	}

	sortCodeFormatted(){
		return this.sortCode ? `Sort Code: ${this.sortCode}` : ""
	}

	formatted({accountName} = {}){
		return [
			this.accountNameFormatted(accountName),
			this.sortCodeFormatted(),
			this.accountNumberFormatted()
		].join(" / ")
	}
}
